import { forwardRef, type Ref, type SVGProps } from "react";
const IconMapDrawOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29.8 5.11 26.89 2.2a.67.67 0 0 0-.48-.2.7.7 0 0 0-.49.2l-6.73 6.74L19 9l-8.86-2.95a.54.54 0 0 0-.28 0L3.45 7.59A2 2 0 0 0 2 9.51v16.84a2 2 0 0 0 2 2 2.2 2.2 0 0 0 .55-.08L9.86 27a.6.6 0 0 1 .27 0l8.7 2.9a.47.47 0 0 0 .33 0l6.63-2.42a2 2 0 0 0 1.21-1.8V8.89l2.8-2.81a.68.68 0 0 0 0-.97M9 25.22l-5 1.13V9.51l5-1.26zm9 2.45-7-2.34V8.38l6.36 2.38-3.72 3.73a.42.42 0 0 0-.14.28l-.5 3.45a.69.69 0 0 0 .19.58.67.67 0 0 0 .48.2l3.55-.5a.42.42 0 0 0 .28-.14l.49-.49zm-1.55-11.08-1.22.18.18-1.22L20.93 10l2.9-2.9 1 1-3.28 3.28zM25 25.68l-5 1.93V15.88l2-2 3-3zm1.22-18.86-1-1 1.3-1.3 1 1z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMapDrawOutlineSVG);
ForwardRef.displayName = "IconMapDrawOutline";
export { ForwardRef as IconMapDrawOutline };
